import type { AppProblemModel } from './AppProblemModel'

/** Retains normalized problem data as a plain object for shared serializable state. */
export const serializeAppProblem = (problem: AppProblemModel): AppProblemModel => ({
  code: problem.code,
  context: problem.context,
  detail: problem.detail,
  fieldIssues: problem.fieldIssues,
  instance: problem.instance,
  isBrandSetupRequired: problem.isBrandSetupRequired,
  message: problem.message,
  name: problem.name,
  params: problem.params,
  reason: problem.reason,
  requestId: problem.requestId,
  retryDelaySeconds: problem.retryDelaySeconds,
  retryable: problem.retryable,
  status: problem.status,
  title: problem.title,
  type: problem.type
})
